import React from 'react';
import cn from 'classnames';
import { OPTION_WRAPPER } from './classnames';
import { MenuProps } from './types';
import MenuItem from './MenuItem';

function Menu<OptionValueType = string>({
  options,
  selected,
  onSelected,
  full,
  clampText,
  dark,
  className = '',
  datatestid,
  'data-testid': dataTestId,
  ...other
}: MenuProps<OptionValueType>) {
  return (
    <div
      className={cn(
        OPTION_WRAPPER,
        dark
          ? 'crehui-scrollable-dark bg-base-light-dark-mode'
          : 'crehui-scrollable bg-white',
        full ? 'w-full' : 'sm:min-w-280',
        className,
      )}
      data-testid={dataTestId || datatestid}
      {...other}
    >
      {options.map(opt => {
        const onSelect = () => {
          if (onSelected) {
            onSelected(opt);
          }
        };

        return (
          <MenuItem
            key={`option-menu-${opt.label}-${opt.value}`}
            onClick={onSelect}
            selected={selected && selected.value === opt.value}
            jsxLabel={opt.jsxLabel}
            label={opt.label}
            clampText={clampText}
            dark={dark}
            data-testid={
              opt['data-testid'] || `${dataTestId || datatestid}-${opt.label}`
            }
          />
        );
      })}
    </div>
  );
}

export default Menu;
